module.exports = __webpack_public_path__ + "img/aboutUs.fd659ba4.png";